<template>
  <div v-if="order != null" class="point_confirm">
    <section class="text_center">
      <h2 class="header_underline">SecurityMoney(セキュリティーマネー)決済確認</h2>
      <p>購入内容</p>
      <table class="table white brown">
        <tr>
          <th>決済金額</th>
          <th>追加ポイント</th>
        </tr>
        <tr>
          <td>{{ order.price.toLocaleString() }}円</td>
          <td>{{ order.point }}pt</td>
        </tr>
      </table>
      <form
        :action="product.action"
        method="post"
        class="form"
        ref="myForm"
      >
        <input type="hidden" v-for="(entry, index) in storeSettings" :key="index" :name="entry.name" :value="entry.value" />
        <input type="hidden" name="sid" :value="orderNum">
        <input type="hidden" name="ch" :value="order.price">
        <input type="hidden" name="u2" :value="errorUrl">
        <div>
          <p>
            <button
              type="submit"
              class="btn arrow"
              :disabled="isSend"
              @click="submit"
            >決済する</button>
          </p>
          <div class="caution">
            <p class="text_left font_annotation--text">上記ご確認の上、「決済する」を押してください。</p>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { API_URL } from '@/common/config'

export default {
  name: 'PointSecuritymoneyConfirm',
  props: {
    order: Object,
    product: Object
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      paymentWay: this.$route.params.paymentWay || null,
      isSend: false
    }
  },
  computed: {
    storeSettings () {
      const settings = []
      if (this.product.store_settings != null) {
        this.product.store_settings.map(g => {
          if (g.key) {
            settings.push({
              name: g.key,
              value: g.value
            })
          }
        })
      }
      return settings
    },
    orderNum () {
      return this.order.environment + this.order.id
    },
    errorUrl () {
      const params = {
        redirect_url: window.location.protocol + '//' + window.location.host + '/point/securitymoney/error',
        isses: this.$route.query.isses
      }
      const urlSearchParam = new URLSearchParams(params).toString()

      return API_URL + 'redirect?' + urlSearchParam
    }
  },
  methods: {
    submit () {
      this.isSend = true
      this.$refs.myForm.submit()
    }
  },
  created () {
    if (this.order == null) {
      this.$router.go(-1)
    }
  }
}
</script>
